import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el PROFEPACK después de comprar?',
  answer: 'Inmediatamente después de confirmar el pago recibís un email automático con el link de descarga de todos los PDF.\n\nComprás → Email llega → Descargás → Usás.\n\nEn menos de 5 minutos tenés todo en tu dispositivo. Sin esperas, sin plataformas raras, sin pedirle nada a nadie.'
}, {
  question: '2 — ¿Sirve para mi provincia o solo para Buenos Aires?',
  answer: 'Sirve para cualquier provincia de Argentina.\n\nEstá basado en los NAP (Núcleos de Aprendizaje Prioritarios) de alcance nacional. Funciona perfectamente en cualquier jurisdicción para docentes de Música de primaria y secundaria.'
}, {
  question: '3 — ¿Es editable? ¿Puedo modificarlo?',
  answer: 'No. Es 100% PDF no editable.\n\nEsto garantiza que el formato sea perfecto en cualquier dispositivo: celular, tablet, computadora, impresora. Sin que se rompa ni se desordene.'
}, {
  question: '4 — ¿Los 6 bonos están en todas las ofertas?',
  answer: 'Sí. En las 3 ofertas siempre.\n\nComprés Primaria ($19.990), Secundaria ($19.990) o Pack Completo ($27.990): los 6 bonos van incluidos sin costo adicional.'
}, {
  question: '5 — ¿Puedo comprar Primaria ahora y Secundaria después?',
  answer: 'Sí, podés hacerlo.\n\nPero si sabés que enseñás en los dos niveles, el Pack Completo te ahorra $7.990 ARS vs. comprarlos por separado.\n\nY con el precio de lanzamiento activo, es el mejor momento para llevarte todo junto.'
}, {
  question: '6 — ¿Funciona si no tengo instrumentos en la escuela?',
  answer: 'Sí. Completamente.\n\nEl Bono #6 "Materiales Cero Presupuesto" tiene 40 materiales cotidianos, 12 dinámicas sin instrumentos para primaria y secundaria y 8 proyectos reciclados paso a paso.\n\nTus clases funcionan aunque la escuela no tenga nada.'
}, {
  question: '7 — ¿Sirve para cursos difíciles o con mucho desorden?',
  answer: 'Sí.\n\nEl Bono #4 "Manual de Manejo de Grupo" tiene protocolos de inicio, señales no verbales, rutinas reset y respuestas concretas para 8 situaciones difíciles reales que enfrentás como docente de Música en primaria y secundaria.'
}, {
  question: '8 — ¿Está actualizado al currículo vigente?',
  answer: 'Sí.\n\nAlineado a los NAP vigentes con contenido actual: streaming, producción digital, rock nacional, folklore, cultura argentina contemporánea integrados con el contenido curricular obligatorio.'
}, {
  question: '9 — ¿Tiene garantía real?',
  answer: 'Sí. 7 días sin preguntas.\n\nUsás todo el material en el aula. Y si no te convence: te devolvemos el 100%. Sin burocracia, sin formularios, sin demoras.'
}, {
  question: '10 — ¿Qué diferencia tiene PROFEPACK con otros packs que vi?',
  answer: 'La diferencia más importante: Otros packs te dan contenido suelto. PROFEPACK te da un sistema completo.\n\nOtros packs tienen ~5 tomos, sin organización por grado, sin guion completo, sin rúbricas, sin actos, sin clases sin instrumentos, solo un nivel, 4 bonos básicos y sin garantía visible.\n\nPROFEPACK tiene 12 tomos, organizado por grado/año, guion completo, rúbricas incluidas, actos con guion y checklist, clases sin instrumentos, primaria Y secundaria, 6 bonos completos y garantía de 7 días.\n\nNo es "más PDFs". Es otro nivel.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-72">
      <div className="max-w-3xl mx-auto" data-id="element-73">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-74">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-75">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#FFD700] bg-[#0d0d00]' : 'border-[#FFD700]/20 bg-black'}`} data-id="element-76">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-77">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-78">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#FFD700] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-79">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-80">
                  <div className="h-px bg-[#FFD700]/20 mb-4" data-id="element-81" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-82">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>

        {/* WhatsApp CTA */}
      </div>
    </section>;
}